const degToRad = (deg) => (deg * Math.PI) / 180;

export const polar2Cartesian = (p) => {
  return {
    x: p.radius * Math.cos(degToRad(p.theta)),
    y: p.radius * Math.sin(degToRad(p.theta))
  };
};
export const MAX_SPIDER = 5;
export const DEFAULT_MAX_VALUE = 10;
export const BASE_DURATION = 400;
export const BASE_DELAY_DURATION = 300;
export const LABEL_NAME = {
  0: "痛み",
  1: "歩行",
  2: "日常",
  3: "転倒",
  4: "可動域"
};
export const COLORS = {
  primary_5: "#E5F2EC",
  primary_4: "#CCE5D9",
  primary_3: "#99CBB3",
  primary_2: "#66B28D",
  primary_1: "#339867"
};
export const ICON_COLORS = {
  bg_icon_1: "#9571FC",
  bg_icon_2: "#32BAB1",
  bg_icon_3: "#F7A659",
  bg_icon_4: "#7D9994",
  bg_icon_5: "#FB84B1"
};
export const cartesian2Canvas = (v, center) => {
  return {
    x: v.x + center.x,
    y: -1 * v.y + center.y
  };
};

export const polar2Canvas = (p, center) => {
  return cartesian2Canvas(polar2Cartesian(p), center);
};

export const getTopPoint = ({ centerPoint, data, radius, withPercent }) => {
  return Array(data.length)
    .fill(0)
    .map((_, i) => {
      const theta = i * (360 / data.length) + 90;
      const percent = data[i].current_score / data[i].max_score;
      return polar2Canvas(
        { radius: withPercent ? radius * percent : radius, theta },
        { x: centerPoint.x, y: centerPoint.y }
      );
    });
};
export const getSpiderWebPoint = ({ centerPoint, data, radius }) => {
  return Array(MAX_SPIDER)
    .fill(0)
    .map((_, index) => {
      return Array(data.length)
        .fill(0)
        .map((_, i) => {
          const theta = i * (360 / data.length) + 90;
          const percent = 1 - index / MAX_SPIDER;
          return polar2Canvas(
            { radius: radius * percent, theta },
            { x: centerPoint.x, y: centerPoint.y }
          );
        });
    });
};

export const getValueWithPercent = (score) => {
  return ((score.current_score / score.max_score) * DEFAULT_MAX_VALUE).toFixed(
    1
  );
};
export const getColorWarningHipScore = (score) => {
  if (score < 5) {
    return "#E50012";
  }

  return "#404040";
};
export const getLabelHorizontalPosition = ({ point, actualSize }) => {
  if (point.x === actualSize / 2) {
    return 0;
  }

  if (point.x > actualSize / 2) {
    return 5;
  }

  return -5;
};
export const getLabelVerticalPosition = ({ point, actualSize }) => {
  if (point.y > actualSize / 2) {
    return 25;
  }

  return -25;
};
